import { createContext, useState, useEffect } from "react";
// hooks
import { useResponsive } from "hooks/index";
// types
import type { FC, PropsWithChildren } from "react";

interface CollapseDrawerContextTypes {
  isCollapse: boolean;
  collapseClick: boolean;
  collapseHover: boolean;
  onToggleCollapse: () => void;
  onHoverEnter: () => void;
  onHoverLeave: () => void;
  isDrawerOpen: boolean;
  onToggleDrawer: () => void;
  onCloseDrawer: () => void;
  onOpenDrawer: () => void;
}
const initialState: CollapseDrawerContextTypes = {
  isCollapse: false,
  collapseClick: false,
  collapseHover: false,
  onToggleCollapse: () => {},
  onHoverEnter: () => {},
  onHoverLeave: () => {},
  isDrawerOpen: false,
  onToggleDrawer: () => {},
  onOpenDrawer: () => {},
  onCloseDrawer: () => {},
};

const CollapseDrawerContext = createContext(initialState);

const CollapseDrawerProvider: FC<PropsWithChildren> = (props) => {
  const { children } = props;
  const isDesktop = useResponsive("up", "lg");

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [collapse, setCollapse] = useState({
    click: false,
    hover: false,
  });

  useEffect(() => {
    if (!isDesktop) {
      setCollapse({
        click: false,
        hover: false,
      });
    }
  }, [isDesktop]);

  const handleToggleCollapse = () => {
    setCollapse({ ...collapse, click: !collapse.click });
  };

  const handleHoverEnter = () => {
    if (collapse.click) {
      setCollapse({ ...collapse, hover: true });
    }
  };

  const handleHoverLeave = () => {
    setCollapse({ ...collapse, hover: false });
  };

  const handleToggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };
  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <CollapseDrawerContext.Provider
      value={{
        isCollapse: collapse.click && !collapse.hover,
        collapseClick: collapse.click,
        collapseHover: collapse.hover,
        onToggleCollapse: handleToggleCollapse,
        onHoverEnter: handleHoverEnter,
        onHoverLeave: handleHoverLeave,
        isDrawerOpen,
        onToggleDrawer: handleToggleDrawer,
        onCloseDrawer: handleCloseDrawer,
        onOpenDrawer: handleOpenDrawer,
      }}
    >
      {children}
    </CollapseDrawerContext.Provider>
  );
};

export { CollapseDrawerProvider, CollapseDrawerContext };
